import { render, staticRenderFns } from "./user.vue?vue&type=template&id=605f3153&scoped=true"
import script from "./user.vue?vue&type=script&lang=ts"
export * from "./user.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f3153",
  null
  
)

export default component.exports